const CONTRACT_BULK_ACTION_TYPE = {
    massAppendices: 'MASS_APPENDICES',
    massCopyContracts: 'MASS_COPY_CONTRACTS',
    massChangeContractState: 'MASS_CHANGE_CONTRACT_STATE',
    massCreateContractDocuments: 'MASS_CREATE_CONTRACT_DOCUMENTS',
    massCreatePayments: 'MASS_CREATE_PAYMENTS',
    massEndContracts: 'MASS_END_CONTRACTS',
    moveContractsToGroup: 'MOVE_CONTRACTS_TO_GROUP',
    moveContractsToNewGroup: 'MOVE_CONTRACTS_TO_NEW_GROUP',
    inflationIncrease: 'INFLATION_INCREASE',
    repriceAndInflationIncrease: 'REPRICE_AND_INFLATION_INCREASE',
    reprice: 'REPRICE',
    valorization: 'VALORIZATION',
    replaceParcelVersions: 'REPLACE_PARCEL_VERSIONS',
}

export default CONTRACT_BULK_ACTION_TYPE